import axios from 'axios'
import { REACT_APP_API } from '../../config'
import { getDate } from '../../../features/presupuestador/NavBudgetList'
import { DATE_OPTION_MAP } from 'common/Constants'


export async function getCampaignDataTable({ page = 1, perPage = 10, sortField = 'start_execution_date', sortOrder = 'DESC', sender, queryDate, search } = {}) {
  try {
    const params = { page, perPage, sortField, sortOrder }
    if (sender) params.sender = sender
    if (search) params.search = search

    if (queryDate) {
      let days
      if (Array.isArray(queryDate)) {
        days = queryDate
      } else {
        days = getDate(DATE_OPTION_MAP[queryDate])
      }
      if (days) {
        params.dateFrom = days[0]
        params.dateTo = days[1]
      }
    }

    const { data } = await axios.get(`${REACT_APP_API}/leads/campaign/getCampaignDataTable`, {
      params,
    })
    return data
  } catch (error) {
    throw new Error(error)
  }
}

